import { loadStyle } from 'components/storefront/editor/easyblocks-page/parser/utils';
import { isLayoutSectionAsset } from './utils';

/** @typedef {import('components/storefront/editor/easyblocks-page/asset-loader').default} AssetLoader */

/**
 * @param {AssetLoader} assetLoader
 */
function processStyle(assetLoader) {
  return {
    shouldProcessNode(node) {
      return node.name === 'style' && !isLayoutSectionAsset(node);
    },
    processNode(node) {
      const hash = node.attribs?.['data-hash'];
      const content = node.children?.[0]?.data;

      const loader = loadStyle(hash, content);

      if (loader) {
        assetLoader.addLayoutAsset(loader);
      }

      return null;
    },
  };
}

export default processStyle;
